import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../redux/actions/mediaActions";
import { FaTrash, FaPlus, FaSave } from "react-icons/fa";

import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { Translate, I18n } from "react-redux-i18n";

function LinkItem(props) {
  return (
    <div className="panel-edit-ad-video__row">
      <input
        type="text"
        id="link"
        name="link"
        data-type="text"
        required
        value={props.item.Url}
        maxLength="100"
        className="panel-edit-ad-input"
        placeholder="https://www.youtube.com/watch?..."
        onChange={props.onChange}
      />
      <button
        type="button"
        className="panel-edit-ad-video__btn"
        onClick={props.onClickSave}
        aria-label="Save"
      >
        <FaSave />
      </button>
      <button
        type="button"
        className="panel-edit-ad-video__btn panel-edit-ad-video__btn--danger"
        onClick={props.onClickRemove}
        aria-label="Remove"
      >
        <FaTrash />
      </button>
    </div>
  );
}

class PanelAddLinkYoutube extends Component {
  state = {
    index: 1,
    values: [],
    links: [{ id: 0, link: "" }],
    media: [],
  };

  componentDidMount() {
    this.syncVideos(this.props.mediaList, this.props.ad);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.mediaList !== this.props.mediaList ||
      prevProps.ad?.Id !== this.props.ad?.Id
    ) {
      this.syncVideos(this.props.mediaList, this.props.ad);
    }
  }

  syncVideos = (mediaList, ad) => {
    const adMedia = Array.isArray(ad?.Media) ? ad.Media : [];
    const sourceList = mediaList.length > 0 ? mediaList : adMedia;
    const videos = sourceList.filter(
      (item) => (item.Type || "").toLowerCase() === "video"
    );
    this.setState({ media: videos });
  };

  componentWillUpdate() {}

  onClickRemove = async (item) => {
    try {
      /* placeholder */
    } catch (error) {
      console.log(error);
    }
  };

  handleChange(i, event) {
    let media = [...this.state.media];
    media[i].Url = event.target.value;
    this.setState({ media });
  }

  onClickAddInput = () => {
    if (this.state.media.length > 2) {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_max_link"),
        function () {}
      );
      return;
    }

    this.setState((prevState) => ({
      ...this.state,
      media: [
        ...this.state.media,
        { Id: "", Name: "", Url: "", Type: "video" },
      ],
    }));
  };

  removeClick = async (item, i) => {
    await this.props
      .RemoveMedia(item.Id, this.props.user_id, this.props.token)
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        } else {
          let values = [...this.state.media];
          values.splice(i, 1);
          this.setState({ media: values });
        }
      });
  };

  saveClick = async (item) => {
    if (item.Url !== "") {
      let params = new FormData();

      params.append("goder_id", this.props.ad?.Id || "");
      params.append("link", item.Url);
      params.append("id", this.props.user_id);
      params.append("media_id", item.Id);

      await this.props.UpdateMedia(this.props.token, params).then(() => {
        if (this.props.error_update) {
          alertify.warning(I18n.t(this.props.error_update));
        } else {
          alertify.success(I18n.t("saved_succesfull"));
        }
      });
    }
  };

  render() {
    const videos = this.state.media.filter((item) => item.Type === "video");

    return (
      <section className="panel-edit-ad-card">
        <h2 className="panel-edit-ad-card__title">
          <Translate value="add_link_youtube" />
        </h2>

        <button
          type="button"
          className="panel-edit-ad-video__add"
          onClick={this.onClickAddInput}
        >
          <FaPlus />
          YouTube
        </button>

        {videos.length > 0 && (
          <div className="panel-edit-ad-video__list">
            {videos.map((item, index) => (
              <LinkItem
                item={item}
                key={item.Id || `new-${index}`}
                onClickRemove={() => {
                  this.removeClick(item, index);
                }}
                onClickSave={() => {
                  this.saveClick(item, index);
                }}
                onChange={(e) => {
                  this.handleChange(index, e);
                }}
              />
            ))}
          </div>
        )}

        <p className="panel-edit-ad-video__hint">
          <Translate value="warning_max_link" />, YouTube
        </p>
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,

    mediaList: reducer.media.list,
  };
}
const mapDispatchToProps = (dispatch) => ({
  RemoveMedia: (id, user_id, token) =>
    dispatch(actions.deleteItem({ id, user_id, token })),
  UpdateMedia: (token, params) => dispatch(actions.newItem({ token, params })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PanelAddLinkYoutube);
